import BRAND from '../brand';
import XpnsrAuthForm from './AuthForm';
import LetsCampaignAuthForm from './AuthFormLetsCampaign';

// Each brand has its own sign-in screen; the auth logic is the same.
// When changing sign-in behaviour, update both files.
export default BRAND.key === 'letscampaign' ? LetsCampaignAuthForm : XpnsrAuthForm;
